export default __webpack_public_path__ + "static/media/democracy.b94fa053.jpg";